import * as React from "react";
import { renderBetButtons } from "./renderBetButtons";
import { prepareEmptyMarket, pickLiveOrPreliveId } from "../../../../../helpers";
/* istanbul ignore next */
export const renderMarkets = (cardProps, buttonsHolderClass, componentPrefix) => {
    let marketsInConfig = cardProps.sport.config.markets;
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${cardProps.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, marketsInConfig.map((m, index) => {
        let market = cardProps.markets.find(market => market.marketType.id === pickLiveOrPreliveId(m, cardProps.event.isLive));
        let emptyMarket = prepareEmptyMarket(cardProps.event.id, m.template, index);
        return renderBetButtons(cardProps, market || emptyMarket, componentPrefix);
    })));
};
//# sourceMappingURL=renderMarkets.js.map